import React, { useContext } from 'react';
import { initialSentenceState } from '../../Sentence/helpers/dummyElement';
import { SentenceAction } from '../../Sentence/hooks/reducer';

type SentenceContextT = {
    sentence: SentenceQueryT;
    dispatchSentence: React.Dispatch<SentenceAction>;
};
const SentenceContext = React.createContext<SentenceContextT>({
    sentence: initialSentenceState,
    dispatchSentence: () => {},
});

export const useSentenceContext = () => useContext(SentenceContext);

export default SentenceContext;
